/* import __COLOCATED_TEMPLATE__ from './upgrade-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();